module.exports = __webpack_public_path__ + "img/Eclipse-Cross-2018.d1246997.jpg";